import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ThemeProvider } from '@emotion/react';
import Theme from './theme/Theme';
import CssBaseline from '@mui/material/CssBaseline';
import {App} from './App'





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <React.StrictMode>
          <ThemeProvider theme={Theme}>
               <CssBaseline />
               <App />
          </ThemeProvider>
     </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

